import type {
  MapActionType,
  RecentMapAction,
} from '../../data-access/types/gp-sampling-assignment';

export function actionHistoryDate(action: RecentMapAction): string {
  const date = new Date(action.created_at);
  return date.toLocaleString(undefined, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function actionTypeLabelKey(actionType: MapActionType): string {
  switch (actionType) {
    case 'assign_sampler':
      return 'actionTypeAssignSampler';
    case 'send_sms':
      return 'actionTypeSendSms';
    case 'make_visible':
      return 'actionTypeMakeVisible';
    case 'reassign_sampler':
      return 'actionTypeReassign';
    case 'confirm_laboratory':
      return 'actionTypeConfirmLab';
    case 'assign_laboratory':
      return 'actionTypeAssignLaboratory';
    case 'unassign_sampler':
      return 'actionTypeUnassignSampler';
    case 'unassign_laboratory':
      return 'actionTypeUnassignLaboratory';
    case 'force_organic_ok':
      return 'actionTypeForceOrganicOk';
    case 'clear_organic_force':
      return 'actionTypeClearOrganicForce';
    default:
      return 'actionTypeUnknown';
  }
}

export function smsDispatchIdFromAction(action: RecentMapAction): number | null {
  if (action.action_type !== 'send_sms') {
    return null;
  }
  const raw = action.payload.dispatch_id ?? action.payload.sms_dispatch_id;
  return typeof raw === 'number' ? raw : null;
}
